import { PhotoIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

const BOX = 'size-11 shrink-0 rounded-control bg-sunken';

/** 44 px square item photo, or a neutral placeholder (also when the file fails to load). Decorative: the name is always next to it. */
export const Thumb = ({ url }: { url?: string | null }) => {
    const [failed, setFailed] = useState<string | null>(null);
    return url && failed !== url ? (
        <img src={url} alt="" loading="lazy" decoding="async" width={44} height={44} onError={() => setFailed(url)} className={`${BOX} object-cover`} />
    ) : (
        <span aria-hidden="true" className={`${BOX} flex items-center justify-center text-muted`}>
            <PhotoIcon className="size-5" />
        </span>
    );
};
